var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import { Group } from '@/models/Group';
import SelectFilter from '@/components/select-filter/SelectFilter';
let SubjectUser = class SubjectUser extends Vue {
};
__decorate([
    PropSync('groups'),
    __metadata("design:type", Array)
], SubjectUser.prototype, "syncedGroups", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], SubjectUser.prototype, "preselectedGroup", void 0);
SubjectUser = __decorate([
    Component({
        components: {
            SelectFilter,
        },
    })
], SubjectUser);
export default SubjectUser;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
